  document.addEventListener("DOMContentLoaded", () => {
    // ✅ HIER ANPASSEN: Selector vo diner Preview-Box
    const previewBox = document.querySelector(".preview-box");
    if (!previewBox) return;

    const radios = document.querySelectorAll('input[name="properties[Ausrichtung]"]');
    if (!radios.length) return;

    function applyMirror() {
      const checked = document.querySelector('input[name="properties[Ausrichtung]"]:checked');
      const isMirrored = checked && checked.value === "gespiegelt";
      previewBox.classList.toggle("is-mirrored", isMirrored);
    }

    // initial
    applyMirror();

    // bi Wechsel
    radios.forEach(r => r.addEventListener("change", applyMirror));
  });